angular.module('bmsApp.settings')
	.factory('FranchiseInstanceSvc', function ($http, $log, $window, $q, CRUDSvc) {
		return {
			options: function () {
				return CRUDSvc.get('api/franchise-instance/options');
			},
		};
	});

